import { CfTextProps } from "../types";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { convertCfTextAlignProps } from "utilities/cfPropTypes/cfTextAlign";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import React from "react";
import Text from "../index";
import parse from "html-react-parser";

export const convertCfTextProps = ({
  titleHeading,
  text,
  ctaList,
  textStyle,
  contentful_id,
}: CfTextProps) => {
  let parsedText = text?.text && parse(text.text);
  if (text && typeof text === "string") {
    parsedText = parse(text);
  }

  const liveInspector: LiveInspectorData = {
    text: ContentfulLivePreview.getProps({
      entryId: contentful_id,
      fieldId: "entryTitle",
    }),
  };

  return {
    titleHeading: titleHeading || "",
    text: parsedText,
    ctaList,
    textTheme: textStyle?.[0].textTheme || undefined,
    liveInspector,
    ...convertCfTextAlignProps(textStyle?.[0].textAlign),
  } as const;
};

const CfText = (props: CfTextProps) => {
  const updatedPost = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id || "" },
  });

  const updatedTextStyleTheme = useContentfulLiveUpdates({
    ...props.textStyle?.[0],
    sys: {
      id: props.textStyle
        ? props.textStyle[0] && props.textStyle[0].contentful_id
        : undefined,
    },
  });

  const updatedTextStyleAlign = useContentfulLiveUpdates({
    ...props.textStyle?.[0].textAlign,
    sys: {
      id: props.textStyle
        ? props.textStyle[0]?.textAlign &&
          props.textStyle[0].textAlign.contentful_id
        : "",
    },
  });

  return (
    <Text
      {...convertCfTextProps({
        ...updatedPost,
        textStyle: [
          {
            ...updatedPost.textStyle?.[0],
            // @ts-expect-error because props.textStyle?.[0].textAlign could not exist so useContentfulLiveUpdates set every inner values as optional
            textAlign: updatedTextStyleAlign,
            textTheme: updatedTextStyleTheme.textTheme || null,
          },
        ],
      })}
    />
  );
};

export default CfText;
